import { render, staticRenderFns } from "./custom-box.vue?vue&type=template&id=e5b9ddf2&scoped=true&"
import script from "./custom-box.vue?vue&type=script&lang=js&"
export * from "./custom-box.vue?vue&type=script&lang=js&"
import style0 from "./custom-box.vue?vue&type=style&index=0&id=e5b9ddf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b9ddf2",
  null
  
)

export default component.exports